var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg018Navigation = function Svg018Navigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "018-navigation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#005454",
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#018-navigation_svg__a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c49.444 49.444 287.628 127.323 386.547 139.065 15.218 1.806 27.935 1.008 38.162-2.322.451 41.414-22.89 59.814-69.162 54.322C256.628 179.323 18.444 101.444-31 52c-23.916-23.917-19.147-44.455-.873-61.978 4.683-4.491 10.412-8.866 16.885-13.105C-12.869-15.764-8.075-8.075 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(67.291 299.987)",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-98.919-11.742-337.103-89.621-386.547-139.065-23.916-23.916-19.148-44.455-.873-61.978 28.395-27.23 94.68-50.325 138.376-63.342 25.393-7.565 45.277-27.407 52.825-52.805 13.233-44.529 36.972-112.595 65.098-140.153 17.17-16.823 37.128-20.582 60.281 2.571C-21.396-405.328 56.483-167.145 68.225-68.225 74.298-17.061 51.164 6.073 0 0Z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(422.839 491.052)",
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 139 139",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(261.012 261)",
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf5"
  })));
};

export default Svg018Navigation;